import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: { user: null, subscription: null },
  reducers: {
    addUser(state, action) {
      state.user = action.payload;
    },
    updateProfile(state, action) {
      state.user.profileUrl = action.payload;
    },
    logout(state, action) {
      state.user = null;
      state.subscription = null
    },
    addSubscription(state, action) {
      state.subscription = action.payload;
    }
  },
});

export const { addUser, updateProfile, logout, addSubscription } = userSlice.actions;
export default userSlice.reducer;
